import Api from "../components/shared/Api";
import { ApiEndpoints } from "../components/shared/Common";
import { IEqUiSelectModel, IGetPopulation } from "../components/shared/interfaces/ILocationDto";
import { EqImageInfoDto } from "../components/shared/interfaces/Images/IImage";

/**
 * Fetches user area options from the API.
 * @returns {Promise<IEqUiSelectModel[] | null>} - A promise resolving to an array of area options or null if an error occurs.
 */
export const UtilGetUserAreaOptions = async (): Promise<IEqUiSelectModel[] | null> => {
    try {
        const response = await Api.get<IEqUiSelectModel[]>(ApiEndpoints.Location.GetUserAreaOptions);
        return response.data;
    } catch (error) {
        console.error("Error fetching areas:", error);
        return null;
    }
};

/**
 * Fetches weekdays from the API.
 * @returns {Promise<IEqUiSelectModel[] | null>} - A promise resolving to an array of weekdays or null if an error occurs.
 */
export const utilGetWeekDays = async (): Promise<IEqUiSelectModel[] | null> => {
    try {
        const response = await Api.get<IEqUiSelectModel[]>(ApiEndpoints.eventGetWeekDays);
        return response.data;
    } catch (error) {
        console.error("Error fetching weekdays:", error);
        return null;
    }
};

/**
 * Fetches population data from the API.
 * @returns {Promise<IGetPopulation[] | null>} - A promise resolving to an array of population data or null if an error occurs.
 */
export const utilGetPopulation = async (): Promise<IGetPopulation[] | null> => {
    try {
        const response = await Api.get<IGetPopulation[]>(ApiEndpoints.eventGetPopulation);
        return response.data;
    } catch (error) {
        console.error("Error fetching population:", error);
        return null;
    }
};

/**
 * Fetches group population data from the API.
 * @returns {Promise<IGetPopulation[] | null>} - A promise resolving to an array of group population data or null if an error occurs.
 */
export const utilGetGroupPopulation = async (): Promise<IGetPopulation[] | null> => {
    try {
        const response = await Api.get<IGetPopulation[]>(ApiEndpoints.eventGetGroupPopulation);
        return response.data;
    } catch (error) {
        console.error("Error fetching group population:", error);
        return null;
    }
};

/**
 * Fetches event images from the API.
 * @returns {Promise<EqImageInfoDto[] | null>} - A promise resolving to an array of event images or null if an error occurs.
 */
export const utilGetImages = async (): Promise<EqImageInfoDto[] | null> => {
    try {
        const response = await Api.get<EqImageInfoDto[]>("image/getEventImages");
        return response.data;
    } catch (error) {
        console.error("Error fetching images:", error);
        return null;
    }
};